import {Component, Input, OnInit} from '@angular/core';
import {FormStrategy} from "../../../../../interface/form-strategy";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ContractItemService} from "../../../../../../core/services/contract-item.service";
import {ISimpleSelectableDataList} from "../../../../../model/interface/simple-selectable-data.model.interface";
import {LegalCase} from "../../../../../model/legal-case.model";

@Component({
  selector: 'app-contract-item-parcel-strategy',
  templateUrl: './contract-item-parcel-strategy.component.html',
  styleUrls: ['./contract-item-parcel-strategy.component.scss']
})
export class ContractItemParcelStrategyComponent implements OnInit, FormStrategy {
  @Input() legalCaseInput!: LegalCase;
  @Input() type!: AbstractControl<any, any>;
  items: ISimpleSelectableDataList;
  parcelForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private contractItemService: ContractItemService) {
    this.createForm();
  }

  private createForm() {
    this.parcelForm = this.formBuilder.group({
      type: null,
      itemId: [null, Validators.required],
      attachment: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.parcelForm.patchValue({type: this.type})
    this.fetchContractItems();
  }

  private fetchContractItems() {
    this.contractItemService.fetchAllForLegalCase(this.legalCaseInput.id)
        .subscribe(list =>
            this.items = list.toSimpleSelectableDataList()
        );
  }

  getForm(): FormGroup<any> {
    return this.parcelForm;
  }

}
